export default (theme) => {
  return {
    panel: {
      width: '100%',
      display: 'flex',
      overflowX: 'auto',
    },
  }
}
